"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../icons/FontAwesome");
var TableMenuIsDefault = /** @class */ (function (_super) {
    __extends(TableMenuIsDefault, _super);
    function TableMenuIsDefault(props) {
        var _this = _super.call(this, props) || this;
        _this.action_default_true = "default:true";
        _this.action_default_false = "default:false";
        return _this;
    }
    TableMenuIsDefault.prototype.doDefaultAction = function (e, RecordKey, RecordTitle) {
        var _default = false;
        if (e.key == this.action_default_true) {
            _default = true;
        }
        if (this.props.onDefaultClick) {
            this.props.onDefaultClick(RecordKey, RecordTitle, _default);
        }
    };
    TableMenuIsDefault.prototype.getDropDownLink = function (record) {
        if (record.isDefault) {
            return (React.createElement("a", { className: "ant-dropdown-link", style: { color: "#FF0000" }, href: "#" },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "clipboard-check" }),
                " ",
                this.props.defaultTexts.text,
                " ",
                React.createElement(FontAwesome_1.FA, { right: true, icon: "chevron-down" })));
        }
        else {
            return (React.createElement("a", { className: "ant-dropdown-link", href: "#" },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "clipboard" }),
                " ",
                this.props.notDefaultTexts.text,
                " ",
                React.createElement(FontAwesome_1.FA, { right: true, icon: "chevron-down" })));
        }
    };
    TableMenuIsDefault.prototype.getIsDefaultDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doDefaultAction(e, record.key, record.title); } },
            React.createElement(antd_1.Menu.Item, { key: this.action_default_false, disabled: !record.isDefault },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "clipboard" }),
                this.props.notDefaultTexts.menu),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_default_true, disabled: record.isDefault },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "clipboard-check" }),
                this.props.defaultTexts.menu)));
    };
    TableMenuIsDefault.prototype.render = function () {
        return (React.createElement(antd_1.Dropdown, { overlay: this.getIsDefaultDropDownMenu(this.props.record), trigger: ['click'] }, this.getDropDownLink(this.props.record)));
    };
    return TableMenuIsDefault;
}(React.Component));
exports.default = TableMenuIsDefault;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_menus/TableMenuIsDefault.tsx
// module id = 89
// module chunks = 0